<div *ngIf="vm$ | async as vm">
  <div *ngIf="vm.isLoggedIn === false; else welcome">
    <div class="govuk-grid-row">
      <div class="govuk-grid-column-two-thirds">
        <govuk-notification-banner heading="Important">
          <p class="govuk-notification-banner__heading">
            The deadline for submitting the second progress update is 5 December 2026.
          </p>
          <p class="govuk-notification-banner__heading">
            The progress update must be signed off by a director(s) (or equivalent) and submitted through MESOS. A
            template for the progress update can be found within the progress update guidance section in MESOS when
            initiating the task.
          </p>
          <p class="govuk-notification-banner__heading">
            The deadlines for the submission of a Notification of Compliance, Action Plan and Initial Progress Updates
            have now passed.
          </p>
          <p class="govuk-notification-banner__heading">
            MESOS will still accept late submissions, but your regulator shall take appropriate enforcement action if it
            is considered necessary to do so.
          </p>
          <p class="govuk-notification-banner__heading">
            You must ensure you respond promptly to any communications you receive from the Environment Agency
            or your regulator.
          </p>
        </govuk-notification-banner>
        <esos-page-heading>Manage your Energy Savings Opportunity Scheme Reporting</esos-page-heading>
        <div class="govuk-body">
          <p>
            The Energy Savings Opportunity Scheme (ESOS) is an energy assessment and energy saving scheme that applies
            to large undertakings and groups containing large undertakings in the UK. This includes:
          </p>

          <ul class="govuk-list govuk-list--bullet govuk-!-margin-left-3">
            <li>corporate bodies or partnerships</li>
            <li>unincorporated associations carrying on a trade or business, with or without a view to profit</li>
            <li>partnerships and limited liability partnerships</li>
            <li>joint ventures</li>
          </ul>

          <h2 class="govuk-heading-m">Who qualifies for ESOS</h2>

          <p>
            You must take part in ESOS if your organisation, or any UK undertakings in your organisation’s group,
            qualifies as a large undertaking on the qualification date.
          </p>

          <p>The qualification date for the third compliance period is 31 December 2022.</p>

          <p>A large undertaking is any UK undertaking that meets one or both of the following conditions:</p>

          <ol class="govuk-list govuk-list--number govuk-list--spaced govuk-!-margin-left-3">
            <li>employs 250 or more people</li>

            <li>
              has an annual turnover in excess of £44 million and an annual balance sheet total in excess of £38 million
            </li>
          </ol>

          <h2 class="govuk-heading-m">How do I notify compliance with ESOS?</h2>

          <p>
            A representative from the responsible undertaking must set up a sign in to create an account on the online
            notification system and fill in the notification requirements. The representative can add an external lead
            assessor to the account to assist with filling in information, but only the responsible undertaking can
            submit the completed notification.
          </p>

          <p>
            Responsible undertakings are by default the highest UK parent in a group acting on behalf of a group of
            qualifying undertakings unless other agreements apply.
          </p>

          <p class="govuk-!-font-weight-bold">
            The wording in the online notification system is for information only and should be read in conjunction with
            the ESOS guidance on
            <a govukLink rel="noreferrer noopener" href="https://www.gov.uk"> gov.uk </a>
            and the regulations on ESOS. In the event of any inconsistency or doubt the regulations should be followed.
          </p>

          <h3 class="govuk-heading-s">Adding an external lead assessor</h3>

          <p>
            An external lead assessor can provide their email address to a responsible undertaking in order to be added
            to the responsible undertaking’s account. This generates an activation email containing a link which the
            lead assessor will use to set up a sign in to create their own account and add it to the responsible
            undertaking’s account.
          </p>

          <p>
            The lead assessor can also create their own account first, and provide the responsible undertaking with
            their email address in order to be added to the responsible undertaking’s account. The lead assessor will
            receive an activation email each time a new responsible undertaking adds the lead assessor to their account.
            Using the same sign in details, the lead assessor will be able to access the new responsible undertaking
            account, and those of all other responsible undertakings to which they have been added.
          </p>
          <br />

          <h3 class="govuk-heading-s">Sign in or register with ESOS</h3>
          <p>
            You'll need to sign in to use this service. if you do not already have sign in details, you will be able to
            create them. You can save your application and come back to it at any time.
          </p>

          <a class="govuk-button govuk-button--start" routerLink="/start-login" draggable="false">
            Start now
            <img class="govuk-button__start-icon" src="/assets/images/start-button-arrow.svg" alt="" />
          </a>
          <br />
        </div>
      </div>

      <div class="govuk-grid-column-one-third">
        <esos-related-content>
          <ul class="govuk-list govuk-!-font-size-16 govuk-list--spaced">
            <li>
              <a
                govukLink
                rel="noreferrer noopener"
                href="https://www.gov.uk/government/publications/comply-with-the-energy-savings-opportunity-scheme-esos/complying-with-the-energy-savings-opportunity-scheme-esos"
              >
                Comply with the Energy Savings Opportunity Scheme
              </a>
            </li>
          </ul>
        </esos-related-content>
      </div>
    </div>

    <div class="govuk-!-margin-bottom-9"></div>
    <esos-back-to-top></esos-back-to-top>
  </div>

  <ng-template #welcome>
    <ng-container [ngSwitch]="vm.status">
      <ng-container *ngSwitchCase="'NO_AUTHORITY'" [ngTemplateOutlet]="apply"></ng-container>
      <ng-container *ngSwitchCase="'ENABLED'" [ngTemplateOutlet]="apply"></ng-container>

      <ng-container *ngSwitchCase="'DISABLED'">
        <ng-container [ngSwitch]="vm.roleType">
          <ng-container *ngSwitchCase="'OPERATOR'" [ngTemplateOutlet]="apply"></ng-container>
          <ng-container *ngSwitchDefault [ngTemplateOutlet]="userDisabled"></ng-container>
        </ng-container>
      </ng-container>

      <ng-container *ngSwitchCase="'ACCEPTED'" [ngTemplateOutlet]="userActivation"></ng-container>
      <ng-container *ngSwitchCase="'TEMP_DISABLED'" [ngTemplateOutlet]="userTempDisabled"></ng-container>
    </ng-container>
  </ng-template>

  <ng-template #userDisabled>
    <esos-page-heading>
      Your user account has been disabled. Please contact your admin to gain access to your account.
    </esos-page-heading>
  </ng-template>

  <ng-template #userActivation>
    <esos-page-heading> Your user account needs to be activated.</esos-page-heading>

    <p class="govuk-body">
      Your user account must be activated by another Advanced User in the organisation account to which you have been
      invited, before you can use the Manage your Energy Savings Opportunity Scheme reporting service. If this is not
      possible, <a govukLink routerLink="/contact-us">contact your Regulator</a>.
    </p>

    <p class="govuk-body">You'll receive an email once your account has been activated.</p>
  </ng-template>

  <ng-template #userTempDisabled>
    <esos-page-heading>Lorem ipsum dolor sit amet. Cum molestiae numquam aut impedit quia non illo.</esos-page-heading>
  </ng-template>

  <ng-template #apply>
    <div class="govuk-body">
      <h1 *ngIf="vm.userProfile as user">Welcome {{ user.firstName }} {{ user.lastName }}</h1>

      <ng-container>
        <div *ngIf="vm.installationEnabled === false" class="govuk-body">
          To access the service you'll need to create a new organisation account
        </div>

        <a govukButton routerLink="/accounts/new">Apply for a new organisation account</a>

        <div class="govuk-body govuk-!-font-weight-bold">
          If you want to be added to an existing organisation account
        </div>

        <div class="govuk-body">
          You can request to be added to an existing organisation account by contacting the relevant organisation
          administrator.
        </div>
      </ng-container>
    </div>
  </ng-template>
</div>
